<script setup lang="ts">
import { RouterView } from 'vue-router';
import SideNavV2 from '@/presentation/components/side-nav/SideNavV2.vue';
import AutoMountPoint from '@/presentation/components/auto-mount-point/AutoMountPoint.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useClient } from '@/presentation/composables/use-client';
import { useTooltip } from '@telecom/shared/composables/use-tooltip';
import { useClassification } from '@telecom/shared/modules/classification-module/use-classification';

import VueElementInspector from '@/presentation/components/VueElementInspector.vue';
import { IpHeader } from '@patsnap-biz/ip-nav';
import { useCommands } from '@telecom/shared/composables/use-commands';
import { useIpNavService } from '@/presentation/components/side-nav/composables/use-ip-nav-service';
import { useLogin } from '@telecom/shared/domain/permission/composables/use-login';

useTooltip();
useClassification();
// 绑定路由参数
const route = useRoute();
const taskId = computed(() => route.query.taskId as string);
const shareId = computed(() => route.query.shareId as string);
const { executeCommand } = useCommands();
const { headerService } = useIpNavService();
const { isLogin } = useLogin();
// 注册主题
const { isEureka } = useClient();
const theme = computed(() => isEureka.value ? 'patsnapRD' : 'patsnapIP');
const isDev = import.meta.env.DEV;
const handleGetStarted = () => {
    executeCommand('login:open-dialog');
};
// 临时解决方案,pricing会嵌入到rd,所以需要去掉头
const isShowHeader = computed(() => route.name !== 'pricing');
</script>

<template>
    <div :data-theme="theme" class="app-container w-full h-full overflow-hidden flex" :class="[isLogin? ' flex-col lg:flex-row': 'flex-col']">
        <template v-if="isShowHeader">
            <SideNavV2 v-if="isLogin" class="flex-shrink-0" />
            <IpHeader
                v-else
                class="flex-shrink-0 z-10"
                :headerService="headerService as any"
                :onGetStarted="handleGetStarted"
            />
        </template>
        <div class="app-body overflow-auto w-full h-full mx-auto">
            <RouterView v-slot="{ Component }">
                <Transition name="fade">
                    <component :is="Component" :key="taskId" />
                </Transition>
            </RouterView>
        </div>

        <AutoMountPoint />
        <VueElementInspector v-if="isDev" />
    </div>
</template>

<style lang="scss">
.app-body {
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
}

[popover] {
    margin: 0;
    padding: 0;
}
</style>
